import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_producao = _resolveComponent("selecionar-tipo-producao")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_unidade_produto_movimento = _resolveComponent("selecionar-unidade-produto-movimento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_engenharia_etapas_producao = _resolveComponent("engenharia-etapas-producao")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "70%",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros scroll-modal"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Engenharia de Produto "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.engenharia.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.engenharia.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativa",
          "un-checked-children": "Inativa",
          disabled: !_ctx.state.editavel
        }, null, 8, ["checked", "disabled"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.engenharia.nome) = $event)),
                          disabled: !_ctx.state.editavel
                        }, null, 8, _hoisted_3), [
                          [_vModelText, _ctx.state.engenharia.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo Produção",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_producao, {
                          varios: false,
                          "codigo-selecionado": _ctx.state.engenharia.codigoTipoProducao,
                          "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.engenharia.codigoTipoProducao) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.PreencherEtapaProducao()))
                        }, null, 8, ["codigo-selecionado", "empresas"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Produto",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_produto, {
                          codigoSelecionado: _ctx.state.engenharia.codigoProduto,
                          "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.engenharia.codigoProduto) = $event)),
                          descricaoSelecionado: _ctx.state.descricao,
                          "onUpdate:descricaoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.descricao) = $event)),
                          apresentarCodigoInterno: true,
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          modoDefinicaoProduto: true,
                          tipoPCP: true
                        }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "UN",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_unidade_produto_movimento, {
                          codigoProdutoDefinicao: _ctx.state.engenharia.codigoProduto,
                          "onUpdate:codigoProdutoDefinicao": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.engenharia.codigoProduto) = $event)),
                          apresentarApenasSigla: true,
                          codigoUnidadeSelecionada: _ctx.state.engenharia.codigoUnidade,
                          "onUpdate:codigoUnidadeSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.engenharia.codigoUnidade) = $event)),
                          sigla: _ctx.state.unidade.sigla,
                          "onUpdate:sigla": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.unidade.sigla) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas
                        }, null, 8, ["codigoProdutoDefinicao", "codigoUnidadeSelecionada", "sigla", "empresas"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Quantidade da Fórmula",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: _ctx.state.engenharia.quantidadeFormula,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.engenharia.quantidadeFormula) = $event)),
                          onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.preencherProdutoAcabado())),
                          "quantidade-casas-decimais": _ctx.state.unidade.casasDecimais
                        }, null, 8, ["valor", "quantidade-casas-decimais"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_engenharia_etapas_producao, {
              etapas: _ctx.state.engenharia.etapasProducao,
              "onUpdate:etapas": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.engenharia.etapasProducao) = $event)),
              controles: _ctx.state.engenharia.controlesProducao,
              "onUpdate:controles": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.engenharia.controlesProducao) = $event)),
              cips: _ctx.state.engenharia.cips,
              "onUpdate:cips": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.engenharia.cips) = $event)),
              tipo: 0,
              editavel: _ctx.state.editavel,
              empresas: _ctx.telaBase.empresasSelecionadas,
              codigoTipoProducao: _ctx.state.engenharia.codigoTipoProducao,
              codigoEngenharia: _ctx.state.engenharia.codigo
            }, null, 8, ["etapas", "controles", "cips", "editavel", "empresas", "codigoTipoProducao", "codigoEngenharia"])
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}